export * as accountCertifications from '@wix/auto_sdk_account-certifications_account-certifications/meta';
